module.exports = __webpack_public_path__ + "img/maker-6.d9d27629.jpg";